import { render, staticRenderFns } from "./WidgetIndicator.vue?vue&type=template&id=1f4f1fda"
import script from "./WidgetIndicator.vue?vue&type=script&lang=js"
export * from "./WidgetIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports